import React from 'react';
import { capabilities } from '../data/mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Capabilities = () => {
  const [headerRef, headerVisible] = useScrollAnimation(0.1);

  return (
    <section id="capabilities" className="relative py-32 lg:py-40">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div
          ref={headerRef}
          className={`max-w-2xl mb-20 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-purple-400 text-sm font-medium tracking-widest uppercase mb-4">Capabilities</p>
          <h2 className="font-display text-4xl lg:text-5xl text-white mb-6">
            Systems We <span className="text-gradient">Engineer</span>
          </h2>
          <p className="text-white/50 text-lg">
            Four pillars of intelligent operations.
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {capabilities.map((capability, index) => (
            <CapabilityCard key={capability.id} capability={capability} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

const CapabilityCard = ({ capability, index }) => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <div
      ref={ref}
      className={`group p-8 lg:p-10 border border-white/5 bg-white/[0.02] hover:border-purple-500/30 hover:bg-white/[0.04] transition-all duration-500 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="flex items-center gap-4 mb-6">
        <h3 className="font-display text-2xl text-white group-hover:text-purple-400 transition-colors">
          {capability.title}
        </h3>
        <span className="text-xs text-purple-400/60 uppercase tracking-wider">{capability.subtitle}</span>
      </div>
      <ul className="space-y-3">
        {capability.items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-3 text-white/50">
            <span className="w-1 h-1 bg-purple-500/50 rounded-full" />
            <span className="text-sm">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Capabilities;
